const NotificationApproved = ({ className, style }: { className?: string; style?: any }) => {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
    >
      <rect width="48" height="48" rx="16" fill="#F3F9EE" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24 15C19.0294 15 15 19.0294 15 24C15 28.9706 19.0294 33 24 33C28.9706 33 33 28.9706 33 24C33 19.0294 28.9706 15 24 15ZM13 24C13 17.9249 17.9249 13 24 13C30.0751 13 35 17.9249 35 24C35 30.0751 30.0751 35 24 35C17.9249 35 13 30.0751 13 24Z"
        fill="#85C553"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M27.7071 21.2929C28.0976 21.6834 28.0976 22.3166 27.7071 22.7071L23.7071 26.7071C23.3166 27.0976 22.6834 27.0976 22.2929 26.7071L20.2929 24.7071C19.9024 24.3166 19.9024 23.6834 20.2929 23.2929C20.6834 22.9024 21.3166 22.9024 21.7071 23.2929L23 24.5858L26.2929 21.2929C26.6834 20.9024 27.3166 20.9024 27.7071 21.2929Z"
        fill="#85C553"
      />
    </svg>
  );
};

export default NotificationApproved;
